import { EditOutlined, LoadingOutlined } from '@ant-design/icons';
import { Boundary, ImageLoader } from 'components/common';
import Popup from 'reactjs-popup';
import AliceCarousel from 'react-alice-carousel';
import { Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import {
  useDocumentTitle, useFileHandler, useModal, useScrollTop
} from 'hooks';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from 'redux/actions/miscActions';
import 'react-alice-carousel/lib/alice-carousel.css';
import * as Yup from 'yup';
import EditForm from '../../account/edit_account/EditForm';
import ConfirmModal from '../../account/edit_account/ConfirmModal';
import { Banner } from '../../../helpers/utils';
import defaultAvatar from '../../../images/defaultAvatar.png';
import banner1 from '../../../images/banner1.jpg';
import banner2 from '../../../images/banner2.jpg';
import banner3 from '../../../images/banner3.jpg';
import banner4 from '../../../images/banner4.jpg';
import banner5 from '../../../images/banner5.jpg';
import banner6 from '../../../images/banner6.jpg';
import {SIGNIN} from '../../../constants/routes';

const FormSchema = Yup.object().shape({
  firstName: Yup.string()
    .max(60, 'First name should be less than 60 characters long.')
    .required('First name is required'),
  lastName: Yup.string()
    .max(60, 'Last name should be less than 60 characters long.')
    .required('Last name is required'),
  email: Yup.string()
    .email('Email is not valid.')
    .required('Email is required.'),
  address: Yup.string()
  .required('Address is required to send registry gifts.'),
  mobile: Yup.object()
    .shape({
      country: Yup.string(),
      countryCode: Yup.string(),
      dialCode: Yup.string(),
      value: Yup.string()
    })
});

const contentStyle = {
  maxWidth: '1000px',
  width: '90%',
  backgroundColor: 'white'
};

const responsive = {
  0: {
    items: 1
  },
  600: {
    items: 2
  },
  1024: {
    items: 3
  }
};

const ProfileForm = (formikProps) => {
  const history = useHistory();
  useDocumentTitle('Edit Account | My Breakup Registry');
  useScrollTop();

  const dispatch = useDispatch();


  useEffect(() => () => {
    dispatch(setLoading(false));
  }, []);

  const {
    errors, touched, imageFile, isLoading, onFileChange, profile, isFileLoading, auth, onConfirmUpdate, banner, setBanner, currentBanner, setCurrentBanner, onSlideChanged, onSelectBanner, modal
  } = formikProps;
  
  if(!auth) history.push(SIGNIN)
  

  return (
    <Boundary>
      <div className="edit-user">
        <div className="user-profile-banner">
          <div className="user-profile-banner-wrapper">
            {Banner(banner)}
            {isFileLoading ? (
              <div className="loading-wrapper">
                <LoadingOutlined />
              </div>
            ) : (
              <label
                className="edit-button edit-banner-button"
                htmlFor="edit-banner"
              >
                <Popup trigger={<EditOutlined />} modal contentStyle={contentStyle}>
                  {(close) => (
                    <div className="m-modal">
                      <a className="m-close" onClick={close}>
                        &times;
                      </a>
                      <div className="m-header"> Choose a Banner </div>
                      <AliceCarousel
                        startIndex={0}
                        fadeOutAnimation
                        onSlideChanged={onSlideChanged}
                        onInitialized={() => setCurrentBanner(1)}
                      >
                        <div className="banner-option">
                          <ImageLoader
                            alt="Banner"
                            className="banner-img"
                            src={banner1}
                          />
                        </div>
                        <div className="banner-option">
                          <ImageLoader
                            alt="Banner"
                            className="banner-img"
                            src={banner2}
                          />
                        </div>
                        <div className="banner-option">
                          <ImageLoader
                            alt="Banner"
                            className="banner-img"
                            src={banner3}
                          />
                        </div>
                        <div className="banner-option">
                          <ImageLoader
                            alt="Banner"
                            className="banner-img"
                            src={banner4}
                          />
                        </div>
                        <div className="banner-option">
                          <ImageLoader
                            alt="Banner"
                            className="banner-img"
                            src={banner5}
                          />
                        </div>
                        <div className="banner-option">
                          <ImageLoader
                            alt="Banner"
                            className="banner-img"
                            src={banner6}
                          />
                        </div>
                      </AliceCarousel>
                      <div className="m-actions">
                        <div className="invite-buttons-container">
                          <button
                            type="button"
                            className="onboard-button"
                            color="primary"
                            onClick={() => {
                              onSelectBanner();
                              close();
                            }}
                          >
                            Select this Banner
                          </button>
                          <button
                            type="button"
                            className="onboard-button"
                            color="primary"
                            onClick={() => {
                              close();
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </Popup>
              </label>
            )}
          </div>
          <div className="user-profile-avatar-wrapper">
            <ImageLoader
              alt="Avatar"
              className="user-profile-img"
              src={imageFile.avatar.url || profile.avatar || defaultAvatar}
            />
            {isFileLoading ? (
              <div className="loading-wrapper">
                <LoadingOutlined />
              </div>
            ) : (
              <label
                className="edit-button edit-avatar-button"
                htmlFor="edit-avatar"
              >
                <input
                  accept="image/x-png,image/jpeg"
                  disabled={isLoading}
                  hidden
                  id="edit-avatar"
                  onChange={(e) => onFileChange(e, { name: 'avatar', type: 'single' })}
                  type="file"
                />
                <EditOutlined />
              </label>
            )}
          </div>
        </div>
        <EditForm
          hideButtons
          authProvider={auth && auth.provider}
          isLoading={isLoading}
        />
        <ConfirmModal
          onConfirmUpdate={onConfirmUpdate}
          modal={modal}
        />
      </div>
    </Boundary>
  );
};

export default ProfileForm;
